import { useEffect, useState } from 'react';

import { useGlobalConfig } from 'src/config/GlobalConfig';

interface Location {
  id: string;
  name: string;
}

interface LocationResponse {
  /**
   * List of locations
   */
  countries: Location[];
  language: string;
}

interface UseLocationsProps {
  /**
   * "ISO 3166-1 alpha-2" code for the language list
   *
   * @defaultValue 'EN'
   */
  language?: string;
}

export const useLocations = ({ language = 'EN' }: UseLocationsProps) => {
  const { locationsApiUrl, supportedLocations } = useGlobalConfig();
  const [locations, setLocations] = useState<LocationResponse['countries']>([]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const url = new URL(
          `${locationsApiUrl}/${language.toLowerCase()}/locations.json`,
        );
        const response = await fetch(url);

        const { countries } = (await response.json()) as LocationResponse;

        const filteredLocations =
          supportedLocations.length > 0
            ? countries.filter((countries) =>
                supportedLocations
                  .map((loc) => loc.toUpperCase())
                  .includes(countries.id.toUpperCase()),
              )
            : countries;

        setLocations(filteredLocations);
      } catch (error) {
        // TODO: log error
        console.error('Unable to fetch location list', error);
      }
    };

    fetchLocations();
  }, [language]);

  return {
    locations,
  };
};
